import axios from 'axios';
import { runtimeConfig } from '../../config';
export const instance = axios.create({
    baseURL: runtimeConfig.PUBLIC_API_URL,
    headers: { 'Access-Control-Allow-Origin': '*' },
});
export const api = {
    get: function apiGet(url) {
        return instance.get(url);
    },
    post: function apiPost(url, data) {
        return instance.post(url, data);
    },
};
export default api;
